import { CallbackComponent } from './callback/callback.component';
import { SpagentComponent } from './spagent/spagent.component';
import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';


const routes: Routes = [{
    path: '',
    component: SpagentComponent,
    children: [{
        path: 'callback',
        component: CallbackComponent,
    }],
}];

@NgModule({
    imports: [
        RouterModule.forChild(routes),
    ],
    exports: [RouterModule],
})

export class SpagentRoutingModule {
}
